import { useState, useEffect, useRef, useCallback } from 'react';

import { getLocalStorage } from 'libs/common';
import { useStateStorage } from './use-state-storage';

const storage = getLocalStorage('sort');

// defaultSort: [{field_name: 'id', direction: 'asc'}]
export const useSort = (key, defaultSort) => {
  const [sort, setSort] = useStateStorage(key, defaultSort, storage);

  return [sort, setSort];
};
